import { useIsNative } from '~/context/common/DeviceContext';
import { useIsInExperiment } from '~/hooks/common';

export default function useIsInReturnUserExperiment() {
  const isNative = useIsNative();
  const isInExperiment = useIsInExperiment(
    'home-return-user-optimize',
    'experiment'
  );

  return isNative ? false : isInExperiment;
}
